module.exports = __webpack_public_path__ + "media/images/products/about/employees-e997bc294057a364f89c491b2dfe60b5.png";